import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import { connect } from "react-redux";
import { useDidUpdate } from "../hooks/useDidUpdate";
import { RESET_ALERT } from "../redux/global/types";
import { DISABLE_GREY } from "../styles";
const SendAlertComp = ({ alert, render, dispatch }) => {
    const [diagVisible, setDiagVisible] = useState(false);
    const { buttonLeftPress, buttonRightPress, buttonLeftText, buttonRightText, ...rest } = alert;
    useDidUpdate(() => {
        if (alert.title) {
            setDiagVisible(true);
        }
    }, [alert]);
    const hideAlert = () => {
        dispatch({ type: RESET_ALERT });
        setDiagVisible(false);
    };
    return (_jsx(_Fragment, { children: render({
            textStyle: { textAlign: "center" },
            visible: diagVisible,
            setVisible: setDiagVisible,
            buttonLeftText: buttonLeftText,
            buttLeftStyle: {
                backgroundColor: DISABLE_GREY,
            },
            buttonLeftPress: () => {
                buttonLeftPress?.();
                hideAlert();
            },
            buttonRightPress: () => {
                buttonRightPress?.();
                hideAlert();
            },
            buttonRightText: buttonRightText || "Ok",
            ...rest,
        }) }));
};
export const SendAlert = connect(({ globalReducer }) => ({
    alert: globalReducer.alert,
}))(SendAlertComp);
